import { useState } from 'react';
import { PersonalDetails } from './Steps/PersonalDetails';
import { Address } from './Steps/Address';
import { SchoolingTarget } from './Steps/SchoolingTarget';
import { LearningMode } from './Steps/LearningMode';
import { HearAboutUs } from './Steps/HearAboutUs';
import { Stepper } from './OnboardingStepper';

const steps = [
  { id: 'personal', title: 'Personal', subtitle: 'Details' },
  { id: 'address', title: 'Address' },
  { id: 'schooling', title: 'Schooling', subtitle: '& Target' },
  { id: 'learning', title: 'Learning', subtitle: 'Mode' },
  { id: 'hearabout', title: 'Hear About', subtitle: 'Us' },
];

export function MultiStepForm({ onComplete }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});

  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    } else {
      handleComplete();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleDataChange = (stepData) => {
    setFormData((prev) => ({
      ...prev,
      [steps[currentStep - 1].id]: stepData,
    }));
  };

  const handleComplete = () => {
    localStorage.setItem('onboardingCompleted', 'true');

    if (onComplete) {
      onComplete();
    }
  };

  const renderCurrentStep = () => {
    const stepProps = {
      onNext: handleNext,
      onPrevious: handlePrevious,
      data: formData[steps[currentStep - 1]?.id],
      onDataChange: handleDataChange,
    };

    switch (currentStep) {
      case 1:
        return <PersonalDetails {...stepProps} />;
      case 2:
        return <Address {...stepProps} />;
      case 3:
        return <SchoolingTarget {...stepProps} />;
      case 4:
        return <LearningMode {...stepProps} />;
      case 5:
        return <HearAboutUs {...stepProps} onComplete={handleComplete} />;
      default:
        return <PersonalDetails {...stepProps} />;
    }
  };

  return (
    <div className="flex flex-col min-h-0 bg-[var(--q3-surface-default)] rounded-3xl px-0 py-6 w-full max-w-2xl mx-auto shadow-none">
      <div className="mb-6">
        <Stepper steps={steps} currentStep={currentStep} />
      </div>
      <div className="px-6">{renderCurrentStep()}</div>
    </div>
  );
}
